var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"-md:hidden"},_vm._l((_vm.list),function(item){return _c('AtomButton',{key:item.key,staticClass:"btn-sm btn-outline btn-tabs ml-2",attrs:{"to":item.to}},[_c('span',{staticClass:"circle w-3 h-3 border border-gray-500 rounded-full mr-[10px]"}),_vm._v("\n    "+_vm._s(item.title)+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }